export default {
  getSubdomain (hostname) {
    const subdomain = hostname.split('.').shift()
    if (subdomain !== hostname) {
      return subdomain
    }
    return ''
  }
}
